import { SrOnly } from '@tvg/fuse-utils';
import styled from 'styled-components';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';

const StyledNav = styled.nav.attrs({
	className: 'fuse-pagination',
})`
	& {
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;

		@media screen and (max-width: ${gridConfig.s.maxWidth}) {
			-webkit-box-pack: space-between;
			-webkit-justify-content: space-between;
			justify-content: space-between;
		}
	}
`;

const OlStyled = styled.ol.attrs({
	className: 'fuse-pagination__page-list',
	'data-testid': 'fuse-pagination__page-list',
})`
	& {
		display: inline-flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
	}
`;

const ListStyled = styled.li.attrs({
	className: 'fuse-pagination__list-item',
	'data-testid': 'fuse-pagination__list-item',
})`
	& {
		list-style: none;
	}

	&:last-child {
		margin-right: 0;
	}
`;

const SrPoliteText = styled(SrOnly).attrs({
	'aria-live': 'polite',
})``;

export { StyledNav, OlStyled, ListStyled, SrPoliteText };
